import { ApiContext, apiContextFetch } from "@/hooks/api/base"

interface AuthUriResponse {
  auth_uri: string
}

interface SalesforceIntegrationStatus {
  connected: boolean
  instance_url: string | null
}

export function getSalesforceAuthUri(context: ApiContext) {
  return apiContextFetch<AuthUriResponse>(context, "salesforce_integration/get_auth_uri")
}

export function fetchSalesforceIntegration(context: ApiContext) {
  return apiContextFetch<SalesforceIntegrationStatus>(context, "salesforce_integration")
}

export function deleteSalesforceIntegration(context: ApiContext) {
  return apiContextFetch<void>(context, "salesforce_integration", {
    method: "DELETE",
  })
}
